module.exports = __webpack_public_path__ + "static/img/service_content5_img.73f460d.png";